/* global youbora */
youbora.registerAdapter('Yospace', require('./adapter'))
module.exports = youbora
